import { defineStore } from "pinia";
import { createClient } from "@/sdk";
import type { WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto } from "~/sdk/generated/models";

export const useDomainAddOnCatalogStore = defineStore(
  "domain-addon-catalog",
  () => {
    const cartStore = useCartStore();
    const config = useRuntimeConfig();

    const client = createClient(config.public.apiServer);

    const isReady = ref(false);
    const catalog =
      ref<
        WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto[]
      >();

    watch(
      () => cartStore.coupon,
      () => {
        isReady.value = false;
        console.log("Coupon changed", cartStore.coupon);
      }
    );

    const fetchCatalog = async () => {
      console.log("fetching catalog");
      const addons = await client.catalog.domainaddons.get({
        queryParameters: {
          coupon: cartStore.coupon,
        },
      });

      catalog.value = addons?.products;
      isReady.value = true;
    };

    watch(
      isReady,
      async () => {
        if (!isReady.value) {
          await fetchCatalog();
        }
      },
      {
        immediate: true,
      }
    );

    return {
      isReady,
      getByType: (addOnType: number) =>
        catalog.value?.find((item) => item.addOnType === addOnType),
      getSubscriptionByAddOnId: (addOnId: number) => {
        return catalog.value
          ?.flatMap((item) => item.subscriptions)
          .find((subscription) => subscription?.addOnId === addOnId);
      },
    };
  }
);
